export const sanitizeName = (name) => {
  const s = name.replace(/_\d+$/, '').replace(/_/g, ' ').toLowerCase()
  return s.charAt(0).toUpperCase() + s.slice(1)
}
